class VariantPickerValue extends HTMLElement {
  url; variantId;
  static class = 'selected';
  
  connectedCallback() {
    this.url = this.dataset.url;
    this.variantId = this.dataset.variant;
  }
  
  getUrl = () => {
    return this.url;
  }

  getId = () => {
    return this.variantId;
  }
}
if(!customElements.get('variant-picker-value')) {
  customElements.define('variant-picker-value', VariantPickerValue);
}

class VariantPicker extends HTMLElement {
  variant;
  
  connectedCallback() {
    this.init();
  }
  
  init = () => {
    this.variant = JSON.parse(this.querySelector('script').innerText);
  }

  getVariant = () => {
    return this.variant;
  }
}
if(!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}